<template>
  <AppLink
    v-if="onlyOneChild.meta"
    :to="resolvePath(onlyOneChild.path)"
    class="single-sidebar-item single-sidebar-item--onboarding"
    :class="{ 'is-collapsed': isCollapsed, 'is-nest': isNest }"
  >
    <el-menu-item
      :index="resolvePath(onlyOneChild.path)"
      :class="
        `menu-item ${
          isNest ? 'menu-item--without-dropdown' : 'menu-item--with-dropdown'
        }`
      "
    >
      <div
        class="menu-item__inner"
        :class="{
          'hide-step-number': onlyOneChild.meta.hideStepNumber,
          'is-completed': onlyOneChild.meta.isCompleted,
          'is-re-opened': onlyOneChild.meta.isReOpened,
        }"
      >
        <SidebarItemTooltip :item="onlyOneChild" :is-collapsed="isCollapsed" />

        <div
          v-if="!onlyOneChild.meta.hideStepNumber"
          class="menu-item__label__step-number"
        >
          <svg-icon
            v-if="onlyOneChild.meta.isReOpened"
            width="20px"
            height="20px"
            icon-class="kyc-update"
          />
          <svg-icon
            v-else-if="onlyOneChild.meta.isCompleted"
            width="24px"
            height="24px"
            icon-class="check-green-small"
          />
          <span v-else>
            {{ onlyOneChild.meta.stepNumber }}
          </span>
        </div>
        <div
          v-if="onlyOneChild.meta.label && (!isCollapsed || isNest)"
          class="menu-item__label"
        >
          {{ $t(onlyOneChild.meta.label) }}
        </div>
      </div>
    </el-menu-item>
  </AppLink>
</template>

<script>
import AppLink from '@/components/SidebarUtils/Link.vue'
import ResolvePathMixin from '@/mixins/resolve-path'
import SidebarItemTooltip from '@/components/SidebarUtils/Tooltip.vue'

export default {
  name: 'SingleSidebarItemOnboarding',
  components: { SidebarItemTooltip, AppLink },
  mixins: [ResolvePathMixin],
  props: {
    basePath: {
      type: String,
      default: '',
    },
    onlyOneChild: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    isKycRoute: {
      type: Boolean,
      default: false,
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    resolvePath(routePath) {
      return this.resolvePathWithBasePath(this.basePath, routePath)
    },
  },
}
</script>

<style lang="scss" scoped>
.single-sidebar-item--onboarding {
  .menu-item__inner {
    padding: 8px;

    &::before {
      display: none;
    }

    .menu-item__label__step-number {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      margin-left: 2px;
      font-size: 12px;
      font-weight: 500 !important;
      line-height: 16px;
      color: #666 !important;
      border: 1px solid #000;
      border-radius: 50%;
    }

    .menu-item__label {
      margin-inline-start: 12px;
    }

    &.hide-step-number {
      .menu-item__label {
        margin-inline-start: 0;
      }
    }

    &.is-completed,
    &.is-re-opened {
      .menu-item__label__step-number {
        width: 24px;
        height: 24px;
        font-size: 24px;
        border: none;
      }
    }
  }
}
</style>
